import { useState } from 'react'

const expertiseItems = [
  {
    num: '01',
    title: 'Property & Engineering',
    copy: 'Assets, infrastructure, projects and operational exposures.',
  },
  {
    num: '02',
    title: 'Energy & Power',
    copy: 'Generation, utilities, petrochemical and energy risks.',
  },
  {
    num: '03',
    title: 'Marine & Cargo',
    copy: 'Transit, hull, ports, terminals and marine operations.',
  },
  {
    num: '04',
    title: 'Aviation',
    copy: 'Aircraft, operators, airports and associated liabilities.',
  },
  {
    num: '05',
    title: 'Life & Health',
    copy: 'Medical, life, health and employee-benefit portfolios.',
  },
  {
    num: '06',
    title: 'Liability & Financial Lines',
    copy: 'Professional, corporate, financial and management risks.',
  },
  {
    num: '07',
    title: 'Agriculture & Climate',
    copy: 'Crop, livestock, weather and climate-linked exposures.',
  },
  {
    num: '08',
    title: 'Specialty Risks',
    copy: 'Terrorism, cyber and other emerging exposures.',
  },
]

function Expertise() {
  const [activeIndex, setActiveIndex] = useState(null)

  function openPanel(index) {
    setActiveIndex(index)
  }

  function closePanels() {
    if (window.matchMedia('(max-width: 900px)').matches) {
      return
    }
    setActiveIndex(null)
  }

  return (
    <section className="expertise-strip">
      <div className="wrap">
        <div className="section-head expertise-intro">
          <div className="eyebrow">Industry expertise</div>
          <h2>
            <span className="intro-title-line">Specialist insight</span>
            <span className="intro-title-line">across complex risks.</span>
          </h2>
          <p>Explore the sectors where technical understanding, market knowledge and disciplined placement strategy make a meaningful difference.</p>
        </div>
        <div
          className="expertise-panels"
          onMouseLeave={closePanels}
        >
          {expertiseItems.map((item, index) => (
            <article
              key={item.num}
              className={activeIndex === index ? 'expertise-panel is-open' : 'expertise-panel'}
              tabIndex="0"
              onMouseEnter={() => {
                if (window.matchMedia('(min-width: 901px)').matches) {
                  openPanel(index)
                }
              }}
              onFocus={() => openPanel(index)}
              onClick={() => {
                if (window.matchMedia('(max-width: 900px)').matches) {
                  setActiveIndex((current) => (current === index ? null : index))
                } else {
                  openPanel(index)
                }
              }}
            >
              <span className="exp-num">{item.num}</span>
              <h3>{item.title}</h3>
              <p>{item.copy}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Expertise
